let useBrowserTimeZone = false;
export const initTimezone = (value) => { useBrowserTimeZone = !!value; };
export const getUseBrowserTimeZone = () => useBrowserTimeZone;
